/**
 * powerMonitor.js — INA226-2B. Lê o bloco de energia INA226 do heartbeat CRU
 * (DeviceOut.last_hb_payload na lista / device-center.heartbeat no detalhe) —
 * os mesmos campos top-level que o firmware esp32c3-ina226 (INA226-1) envia.
 *
 * Default-safe / GATED: device comum (sem os campos) → extractPowerMonitor()
 * retorna null, então o NOC não mostra nada (sem bloco/chip vazio).
 */
function _num(v) {
  return typeof v === "number" ? v : null;
}

/** Retorna o estado normalizado de energia, ou null se o device não é INA226. */
export function extractPowerMonitor(hb) {
  if (!hb || typeof hb !== "object") return null;
  const supported = hb.power_monitor_supported === true;
  const status = typeof hb.ina226_status === "string" ? hb.ina226_status : null;
  const ok = typeof hb.ina226_ok === "boolean" ? hb.ina226_ok : null;
  const busMv = _num(hb.bus_voltage_mv);
  const currentMa = _num(hb.current_ma);
  const powerMw = _num(hb.power_mw);
  // GATE: só é "device de energia" se reportou a capability OU algum dado INA226.
  if (!supported && ok == null && status == null &&
      busMv == null && currentMa == null && powerMw == null) {
    return null;
  }
  return {
    supported,
    ok,
    status,
    busMv,
    currentMa,
    powerMw,
    shuntUv: _num(hb.shunt_voltage_uv),
    address: _num(hb.ina226_address),
    // sensor ausente/erro → realce âmbar/vermelho na UI.
    bad: ok === false || status === "missing" || status === "error",
  };
}

export const fmtVolt = (mv) => (mv != null ? `${(mv / 1000).toFixed(2)} V` : null);
export const fmtAmp = (ma) =>
  (ma == null ? null : (Math.abs(ma) < 1000 ? `${ma} mA` : `${(ma / 1000).toFixed(2)} A`));
export const fmtWatt = (mw) => (mw != null ? `${(mw / 1000).toFixed(2)} W` : null);

/** Rótulo legível do status do sensor. */
export function powerStatusLabel(pm) {
  if (!pm) return null;
  const s = pm.status;
  if (s === "ok") return "OK";
  if (s === "missing") return "ausente";
  if (s === "error") return "erro de leitura";
  if (s === "disabled") return "desabilitado";
  if (pm.ok === true) return "OK";
  if (pm.ok === false) return "indisponível";
  return s;
}

/** Texto compacto do chip da lista: "12.3V · 0.80A · 9.8W" | "missing" | "erro". */
export function powerChipText(pm) {
  if (!pm) return null;
  if (!pm.ok) return pm.status || "—";
  const parts = [];
  if (pm.busMv != null) parts.push(`${(pm.busMv / 1000).toFixed(1)}V`);
  if (pm.currentMa != null) {
    parts.push(
      Math.abs(pm.currentMa) < 1000
        ? `${pm.currentMa}mA`
        : `${(pm.currentMa / 1000).toFixed(2)}A`,
    );
  }
  if (pm.powerMw != null) parts.push(`${(pm.powerMw / 1000).toFixed(1)}W`);
  return parts.length ? parts.join(" · ") : (pm.status || "ok");
}
